import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrl: './payment.component.scss'
})
export class PaymentComponent {
  id: any;
  products: any;
  dropdownPrice:boolean=false;

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private local: LocalServiceService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    let { id } = this.local.getUser();
    this.id = id;
    this.get_all_stripe_products();
    this.vip_token_transactions()
    this.route.queryParams.subscribe((res: any) => {
      console.log(res)
      if (res.hasOwnProperty('status')) {
        if (res.status == 'success') {
          Swal.fire(
            'Done',
            'Payment done successfully. Credits are added to your account.',
            'success'
          ).then(() => {
            window.location.href = window.location.href.split("?")[0];
          });
        }

        if (res.status == 'sub-success') {
          Swal.fire(
            'Done',
            'Subscription was created successfully.',
            'success'
          ).then(() => {
            window.location.href = window.location.href.split("?")[0];
          });
        }

        if(res.status == 'cancelled') {
          Swal.fire(
            'Cancelled',
            'Payment is cancelled or some error has occured during the payment.',
            'error'
          ).then(() => {
            window.location.href = window.location.href.split("?")[0];
          });
        }

        if(res.status == 'blocked') {
          Swal.fire({
            title: "Account Blocked",
            text: "Your account has been blocked by the admin.",
            icon: 'warning',
            confirmButtonColor: '#141631',
            confirmButtonText: 'OK',
            allowOutsideClick: false
          }).then(() => {
            window.location.reload();
          });
          this.local.logout();
        }
      } 
    }); 
  }
  transactions: any;
  total_txn: number = 0;
  vip_token_transactions() {
    this.auth.vip_token_transactions().subscribe((response: any) => {
      this.transactions = response.body.transactions;
      this.total_txn = response.body.available;
          
    }, (error) => {
      if (error.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      }
    });
  }
  view_all_transactions(modal) {
    this.modalService.open(modal, { size: 'md', ariaLabelledBy: 'modal-basic-title' });
  }

  managesubscription(sub_type) {
    let formData = new FormData();
    formData.append('id', this.id);
    formData.append('stripe_price_id', 'xxx');
    formData.append('tokens', 'xxx');
    formData.append('notification_code', 'xxx');
    formData.append('sub_type', sub_type);

    this.auth.create_stripe_checkout_url(formData).subscribe((response: any) => {

      window.location.href = response.body.url;

    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message)
      }
    });
  }
  get_all_stripe_products() {
    this.auth.get_all_stripe_products().subscribe((response: any) => {
      this.products = response.body.reverse().slice(0,4);
    }, (error) => {
      if (error.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      }
    });
  }

  subscribeto(token,subc=0,notification_code='DEFAULT') {
    let stripe_price_id = '';
    let tokens = 'zzz';
    let sub_type = "1";
    if (token == 1) {
      stripe_price_id = 'price_1Mk7iaJSfPyvcn3RHcDm1RSj';  
      // stripe_price_id = 'price_1MqKK8JSfPyvcn3RFli3XQIa'; // test // 149
    } else if (token == 2) {
      stripe_price_id = 'price_1Mk7j0JSfPyvcn3R9nVjIF8p'; 
      // stripe_price_id = 'price_1MqKKSJSfPyvcn3R8o18jaQk'; // test // 219
    } else if (token == 3) {
      stripe_price_id = 'price_1Mk7jLJSfPyvcn3RpNDtHpbN'; 
      // stripe_price_id = 'price_1MqKKxJSfPyvcn3RfWog8PMS'; // test // 259
    } else if (token == 4) {
      stripe_price_id = 'price_1NnlR5JSfPyvcn3RRwhcsvm0'; 
      // stripe_price_id = 'price_1MqKLAJSfPyvcn3R8umgYDWB'; // test // live 255
    } else if (token == 5) {
      stripe_price_id = 'price_1NnlRmJSfPyvcn3RTMSqtFbG'; 
      // stripe_price_id = 'price_1MqKLPJSfPyvcn3RgNRqpxCi'; // test // live 759
    } else if (token == 6) {
      stripe_price_id = 'price_1NnlS3JSfPyvcn3RoTVYRI0y'; 
      // stripe_price_id = 'price_1MqKLeJSfPyvcn3R3RTOJYcJ'; // test // live 1450
    } else if (token == 7) {
      stripe_price_id = 'price_1QuxXg03HSHmHwgRGPBP70g7'; // old 219 now 199
     // stripe_price_id = 'price_1QyFss03HSHmHwgRFHrAOzv7'; // test // 199 
    } else if (token == 8) {
      stripe_price_id = 'price_1QuxYY03HSHmHwgR9YqI5dKH'; // old 259 now 299
     // stripe_price_id = 'price_1QyFtZ03HSHmHwgRaKS8xLay'; // test // 299
    } else if (token == 9) {
      stripe_price_id = 'price_1PJJXt03HSHmHwgRqggswqbW';
     // stripe_price_id = 'price_1PIdId03HSHmHwgRt7PZzZ9v'; // test // live 255
    } else if (token == 10) {
      stripe_price_id = 'price_1PJJXy03HSHmHwgRywMeR3aD';
     // stripe_price_id = 'price_1PIdIu03HSHmHwgRRdn5axi1'; // test // live 759
    } else if (token == 11) {
      stripe_price_id = 'price_1PJJY203HSHmHwgRRf1bYPvb';
      //stripe_price_id = 'price_1PIdJ803HSHmHwgREjpGZ1fh'; // test // live 1450
    } 

    if (token > 6 && token <= 11) {
      sub_type = "2";
    }


   
    let formData = new FormData();
    formData.append('id', this.id);
    formData.append('stripe_price_id', stripe_price_id);
    formData.append('tokens', tokens);
    formData.append('token', token);
    formData.append('sub', subc.toString());
    formData.append('notification_code', notification_code);
    formData.append('sub_type', sub_type);

    this.auth.create_stripe_checkout_url(formData).subscribe((response: any) => {

      if (response.body.url != "r")
        window.location.href = response.body.url;
      else if (response.body.message != "") { 
        if (response.body.code == 0) {
          this.subscribeto(token, 1, response.body.notification_code);
          return;
        }
        Swal.fire({
          title: 'Previous Subscription found!',
          text: response.body.message,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Accept'
        }).then((result) => {
          
          if (result.isConfirmed) {

            if (response.body.code != 2) {
              this.subscribeto(token, 2, response.body.notification_code);
            }
            
          }
        });
      }
    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message)
      }
    });
  }

  isSectionVisible = false;
  toggleSectionmain() {
    this.isSectionVisible = !this.isSectionVisible;
  }

  isSectionVisiblec = false;
  toggleSectionc() {
    this.isSectionVisiblec = !this.isSectionVisiblec;
  }

  stripe(stripe_price_id, tokens, notification_code) {
    Swal.fire({
      title: 'Terms of purchase',
      text: "VIP Tokens expire in 365 days from the date of purchase and non-refundable and non-exchangeable.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Accept'
    }).then((result) => {
      if (result.isConfirmed) {
        let formData = new FormData();
        formData.append('id', this.id);
        formData.append('stripe_price_id', stripe_price_id);
        formData.append('tokens', tokens);
        formData.append('notification_code', notification_code);

        this.auth.create_stripe_checkout_url(formData).subscribe((response: any) => {
      
          window.location.href = response.body.url;

        }, (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message)
          }
        });
      }
    });
  }

}

